import React, {lazy, Suspense} from 'react';

const TheToggle = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./TheToggle'));

const Toggle = (props) => {
    return <Suspense fallback={null}>
        <TheToggle {...props} />
    </Suspense>
}

export default Toggle;